import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../../localization/localization.service';

@Pipe({
  name: 'localization',
})
export class LocalizationPipe implements PipeTransform {
  constructor(
    private localizationService: LocalizationService,
  ) {
  }

  transform(value: any, dictionary: {[key: string]: { [key: string]: string }}): any {
    const locale = this.localizationService.getLocale();
    return dictionary[locale] && dictionary[locale][value] || value;
  }
}
